import { useField } from "react-final-form";

export function useFieldValue<T>(name: string) {
  const {
    input: { value },
  } = useField<T>(name);
  return value;
}
